/**
 * 商品管理路由
 * @Description: 商品管理模块路由及完整子路由
 *
 * @Author: JZT.Oscar
 * @Date: 2018-10-12 08:57:14
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2018-11-15 16:58:43
 */

export default [
    {
        path: "/customerManage/customerList",
        name: "客户列表",
        component: () => import("@/pages/customerManage/customerList"),
        icon: "none",
        meta:{
            comName:"customerList",
            needRefresh: true
        }
    },
    {
        path: "/customerManage/custTransmit",
        name: "站点转发",
        component: () => import("@/pages/customerManage/custTransmit"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"custTransmit"
        }
    }, {
        path: "/customerManage/customerqualifie",
        name: "审核客户资质",
        component: () => import("@/pages/customerManage/customerQualifie"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"customerqualifie"
        }
    }, {
        path: "/customerManage/custQuaUpdate",
        name: "审核客户更新",
        component: () => import("@/pages/customerManage/custQuaUpdate"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"custQuaUpdate"
        }
    }, {
        path: "/customerManage/customerDetails",
        name: "客户详情",
        component: () => import("@/pages/customerManage/customerDetails"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"customerDetails"
        }
    },
    {
        path: "/customerManage/relationshipList",
        name: "建采列表",
        component: () => import("@/pages/customerManage/relationshipList"),
        icon: "none",
        meta:{
            comName:"relationshipList",
            needRefresh: true
        }
    },
    {
        path: "/customerManage/relationsDetails",
        name: "建采客户详情",
        component: () => import("@/pages/customerManage/relationsDetails"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"relationsDetails"
        }
    },
    {
        path: "/customerManage/relationsQualifie",
        name: "审核建采关系",
        component: () => import("@/pages/customerManage/relationsQualifie"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"relationsQualifie"
        }
    },
    {
        path: "/customerManage/relationsUpdate",
        name: "审核建采更新",
        component: () => import("@/pages/customerManage/relationsUpdate"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"relationsUpdate"
        }
    },
    {
        path: "/customerManage/relationsMailing",
        name: "审核等待邮寄",
        component: () => import("@/pages/customerManage/relationsMailing"),
        icon: "none",
        invisible: true,
        meta:{
            comName:"relationsMailing"
        }
    },
    {
        path: "/customerManage/erplist",
        name: "ERP客户清单",
        component: () => import("@/pages/customerManage/erpList"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "customerList"
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/customer.js